import type {
  AutocompleteResponse,
  GeocodingResponsePayload,
  PharosApiResponse,
  PostalAddress,
} from '@klareospace/pharos-lib-types';

import type { ApiClient } from '../api';

// ─── Params ───────────────────────────────────────────────────────────────────

export interface AutocompleteParams {
  at: string;
  lang?: string;
  limit?: number;
  query: string;
  signal?: AbortSignal;
}

// ─── API Factory ──────────────────────────────────────────────────────────────

export type GeocodingApi = {
  autocomplete: (params: AutocompleteParams) => Promise<AutocompleteResponse>;
  geocode: (address: PostalAddress) => Promise<GeocodingResponsePayload>;
};

export function createGeocodingApi(client: ApiClient): GeocodingApi {
  return {
    autocomplete: async (params: AutocompleteParams): Promise<AutocompleteResponse> => {
      const { signal, ...body } = params;
      const response = await client.execute<PharosApiResponse<AutocompleteResponse>>(() =>
        client.instance.post('/geocoding/autocomplete', body, { signal }),
      );
      if (!response.data) {
        throw new Error('autocomplete: unexpected empty response');
      }
      return response.data;
    },

    geocode: async (address: PostalAddress): Promise<GeocodingResponsePayload> => {
      const response = await client.execute<PharosApiResponse<GeocodingResponsePayload>>(() =>
        client.instance.post('/geocoding', address),
      );
      if (!response.data) {
        throw new Error('geocode: unexpected empty response');
      }
      return response.data;
    },
  };
}
